export const calendarFilters = {
    GET_FILTERS_OF_CALENDAR: "GET_FILTERS_OF_CALENDAR",
    GET_FILTERS_OF_CALENDAR_SUCCESS : "GET_FILTERS_OF_CALENDAR_SUCCESS",
    GET_FILTERS_OF_CALENDAR_NULL : "GET_FILTERS_OF_CALENDAR_NULL",
    GET_FILTERS_OF_CALENDAR_ERROR : "GET_FILTERS_OF_CALENDAR_ERROR",
    GET_NEW_FILTERS_OF_CALENDAR_ON_SCROLL : "GET_NEW_FILTERS_OF_CALENDAR_ON_SCROLL",
    CLEAR_FILTERS_OF_CALENDAR_FILTERS : "CLEAR_FILTERS_OF_CALENDAR_FILTERS",
}